import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { AnnouncementPanel } from '@innovamat/glimmer-components';

import type { Classroom } from '../../../../modules/classroom';
import { ClassSelectCard } from '../../components/class-select-card';
import { useJoinToClassroom } from '../../join-to-classroom-context';
import { ClassroomsPerCourse, Container } from '../../join-to-classroom.styled';
import { SelectStepSkeleton } from '../shared/select-classrooms-step.skeleton';

import { SelectGroupsEmptyState } from './select-groups-empty-state';

function SelectJourneysStep(): JSX.Element {
  const { t } = useTranslation();
  const {
    classrooms,
    classroomsQueryError,
    getCardStatus,
    handleClick,
    isLoadingClassrooms,
    openEditModal,
  } = useJoinToClassroom();

  const [isFakeLoading, setIsFakeLoading] = useState(true);

  useEffect(() => {
    setTimeout(() => {
      setIsFakeLoading(false);
    }, 500);
  }, []);

  if (isLoadingClassrooms || isFakeLoading) {
    return (
      <Container>
        <SelectStepSkeleton />
      </Container>
    );
  }

  return (
    <Container>
      {classroomsQueryError && (
        <AnnouncementPanel
          text={t('classrooms.steps.select-journeys.request.error')}
          type="error"
          canClose={false}
        />
      )}
      <ClassroomsPerCourse>
        {classrooms.map((classroom) => (
          <ClassSelectCard
            key={`card-${classroom.id}`}
            dataTestId={`journey-select-${classroom.id}`}
            classroom={classroom}
            onClick={() => handleClick(classroom)}
            onClickEdit={() => openEditModal(classroom as Classroom)}
            status={getCardStatus(classroom.id)}
          />
        ))}
      </ClassroomsPerCourse>
      {!classrooms.length && <SelectGroupsEmptyState />}
    </Container>
  );
}

export { SelectJourneysStep };
